export const dialogTitles = {
    deleteTemplate: 'Are you sure you want to delete this template?',
    deletePackage: 'Are you sure you want to delete this package?',
    moveToDev: 'Are you sure you want to move this package to development?',
    moveToProd: 'Are you sure you want to move this package to production?',
    moveIntegratedToProd: 'Are you sure you want to move this package to production?',
    rejectDev: 'Are you sure you want to discard this version to move to dev for testing?',
    rejectProd: 'Are you sure you want to discard this version to move to production?',
    markTested: 'Are you sure you want to mark this version Tested?',
    disableDev: 'Are you sure you want to disable this package on dev?',
    disableProd: 'Are you sure you want to disable this package on production?',
    removeDev: 'Are you sure you want to remove this package from dev?',
    removeProd: 'Are you sure you want to remove this package from production?',
    
};

export const dialogMap = {
    disableDev: { type: "disable", destination: "dev" },
    disableProd: { type: "disable", destination: "prod" },
    removeDev: { type: "remove", destination: "dev" },
    removeProd: { type: "remove", destination: "prod" },
};
